import { z } from 'zod';
import { toFormikValidationSchema } from 'zod-formik-adapter';
import { baseString } from './core/primitives';
import { str } from './core/helpers';
import { changePasswordSchema } from './auth';

const NON_ENGLISH_DIGITS = /[٠-٩۰-۹]/;
const MIN_PHONE_DIGITS = 10;
const MAX_PHONE_DIGITS = 15;

const username = (t) =>
  z.preprocess(str, baseString.min(1, t('validation.username.required')));

const phone = (t) =>
  z.preprocess(
    str,
    z
      .string()
      .min(1, t('validation.phone.required'))
      .refine(
        (val) => !NON_ENGLISH_DIGITS.test(val),
        t('validation.phone.englishOnly')
      )
      .refine((val) => {
        const digits = val.replace(/\D/g, '');
        return (
          digits.length >= MIN_PHONE_DIGITS && digits.length <= MAX_PHONE_DIGITS
        );
      }, t('validation.phone.invalidLength'))
  );

const email = (t) =>
  z.preprocess(
    str,
    baseString
      .toLowerCase()
      .min(1, t('validation.email.required'))
      .pipe(z.email(t('validation.email.invalid')))
  );

const category = (t) =>
  z.preprocess(str, baseString.min(1, t('validation.category.required')));

const role = (t) =>
  z.preprocess(str, baseString.min(1, t('validation.user.role.required')));

export const personalInfoSchema = (t) => z.object({ username: username(t) });

export const contactInfoSchema = (t) =>
  z.object({
    email: email(t),
    phone: phone(t),
  });

export const roleInfoSchema = (t) =>
  z.object({
    category: category(t),
    categoryName: z.string().optional(),
    role: role(t),
  });

export const createPasswordSchema = (t, requireCurrentPassword) =>
  toFormikValidationSchema(changePasswordSchema(t, requireCurrentPassword));
